<template>
  <div>
    <v-card class="px-2 py-1">
      <v-row no-gutters align="center" justify="space-between" class="mt-2 mb-2">
        <div>
          <v-btn
            outlined
            class="primary"
            color="white"
            @click="setToday"
          >
            Hoje
          </v-btn>
          <v-btn
            class="ui-btn-clean ml-2 mr-1"
            @click="prev"
          >
            <v-icon color="primary">
              chevron_left
            </v-icon>
          </v-btn>
          <v-btn
            class="ui-btn-clean ml-1"
            @click="next"
          >
            <v-icon color="primary">
              chevron_right
            </v-icon>
          </v-btn>
        </div>
        <div class="text-h2 text-primary text-title-calendar text-uppercase">
          {{ mesAno }}
        </div>
        <v-menu
          bottom
          right
          offset-y
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              outlined
              color="primary"
              v-bind="attrs"
              v-on="on"
            >
              <span>{{typeToLabel[type]}}</span>
              <v-icon right>
                expand_more
              </v-icon>
            </v-btn>
          </template>
          <v-list>
            <v-list-item @click="setTypeDay('day')">
              <v-list-item-title>Dia</v-list-item-title>
            </v-list-item>
            <v-list-item @click="setTypeDay('week')">
              <v-list-item-title>Semana</v-list-item-title>
            </v-list-item>
            <v-list-item @click="setTypeDay('month')">
              <v-list-item-title>Mês</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </v-row>
      <v-sheet :class="'height_sheet'">
        <v-calendar
          ref="calendar"
          v-model="focus"
          color="primary"
          :events="events"
          :event-color="getEventColor"
          :type="type"
          :interval-height="150"
          :event-overlap-mode="'column'"
          :event-name="eventName"
          :event-class="'tarefa_info'"
          @click:more="viewDay"
          @click:date="viewDay"
          @click:event="showEvent"
          @change="updateRange"
        >
          <template v-slot:day-body="{ date, week }">
            <div
              class="v-current-time"
              :class="{ first: date === week[0].date }"
              :style="{ top: nowY }"
            ></div>
          </template>
        </v-calendar>
      </v-sheet>
    </v-card>
  </div>
</template>

<script>
import Api from '@API'
import moment from 'moment'

export default {
  props: ['refresh'],
  data () {
    return {
      valorCalendario: null,
      ready: false,
      focus: '',
      mesAno: '',
      type: 'month',
      de: moment().startOf('month').format('YYYY-MM-DD'),
      ate: moment().endOf('month').format('YYYY-MM-DD'),
      typeToLabel: {
        month: 'Mês',
        week: 'Semana',
        day: 'Dia'
      },
      events: [],
      colors: ['blue', 'indigo', 'deep-purple', 'cyan', 'green', 'orange', 'grey darken-1'],
      statusArr: [
        {
          text: 'Aberto',
          color: 'blue',
          value: 1
        },
        {
          text: 'Adiado',
          color: 'amber accent-4',
          value: 2
        },
        {
          text: 'Cancelado',
          color: 'red',
          value: 3
        },
        {
          text: 'Concluído',
          color: 'green',
          value: 4
        }
      ],
      names: ['tomar banho', 'ir fazer algo', 'alguma coisa', 'Ortodontia', 'Implantodontia', 'Aniversário', 'Conferencia', 'Rolezinho'],
      selectedEvent: {},
      selectedElement: null,
      selectedOpen: false
    }
  },
  watch: {
    refresh () {
      if (!this.refresh) return false
      this.getTarefas()
      this.$emit('reset-refresh')
    }
  },
  computed: {
    cal () {
      return this.ready ? this.$refs.calendar : null
    },
    nowY () {
      return this.cal ? this.cal.timeToY(this.cal.times.now) + 'px' : '-10px'
    }
  },
  mounted () {
    this.$refs.calendar.checkChange()
  },
  methods: {
    updateRange ({ start, end }) {
      this.de = start.date
      this.ate = end.date
      this.getTarefas()
    },
    async getTarefas () {
      this.carregando = true
      this.total = 0

      let endpoint = ''

      if (this.de) endpoint += `&de=${this.de}`
      if (this.ate) endpoint += `&ate=${this.ate}`

      await Api.get(`tarefas?filter=${endpoint}`)
        .then(res => {
          if (res.data) {
            let info = []
            this.dados = []
            if (res.data.length > 0) {
              res.data.map(item => {
                info.push({
                  ...item,
                  name: item.tar_descricao,
                  start: moment(item.tar_data).format('YYYY-MM-DD'),
                  color: this.statusArr[item.tar_status - 1].color,
                  status: item.tar_status,
                  timed: false
                })
              })
            }
            this.mesAno = this.$refs.calendar.title
            this.events = info
          }
          this.carregando = false
          this.ready = true
        })
        .catch(err => {
          this.carregando = false
          this.$root.SnackControl.open(this, {
            text: err.response.data.status ? err.response.data.status : 'Ops, ocorreu um erro ao buscar as tarefas!',
            color: 'error'
          })
          console.log(err)
        })
    },
    showEvent (item) {
      this.$emit('abre-tarefa', item.event)
    },
    getEventColor (event) {
      return event.color
    },
    viewDay ({ date }) {
      this.focus = date
      this.type = 'day'
      setTimeout(() => {
        this.scrollToTime()
      }, 500)
    },
    setTypeDay (tipo) {
      this.type = tipo
    },
    setToday () {
      this.focus = ''
    },
    setNewDateInterval (type) {
      if (type === 'next') {
        this.de = moment(this.de).add(1, this.type)
      }
      if (type === 'prev') {
        this.de = moment(this.de).subtract(1, this.type)
      }
      this.de = moment(this.de).startOf(this.type).format('YYYY-MM-DD')
      this.ate = moment(this.de).add(3, 'month').endOf(this.type).format('YYYY-MM-DD')

      this.getTarefas()
    },
    prev () {
      this.$refs.calendar.prev()
    },
    next () {
      this.$refs.calendar.next()
    },
    getCurrentTime () {
      return this.cal ? this.cal.times.now.hour * 60 + this.cal.times.now.minute : 0
    },
    scrollToTime () {
      const time = this.getCurrentTime()
      const first = Math.max(0, time - (time % 30) - 30)

      this.cal.scrollToTime(first)
    },
    eventName (e) {
      if (e.input.status === 3) return `<del><b>${e.input.name}</b></del>`
      return `<b>${e.input.name}</b>`
    },
    updateTime () {
      setInterval(() => this.cal.updateTimes(), 60 * 1000)
    },
    loadFunctions () {
      this.getTarefas()
      setTimeout(() => {
        this.scrollToTime()
      }, 1500)
      this.updateTime()
    },
    loadContent () {
      this.loadFunctions()
    }
  },
  created () {
    this.loadContent()
  }
}
</script>
<style lang="scss" scoped>
@import "@scss/_variables.scss";
@import "@scss/_ui.scss";
.height_sheet {
  height: calc(100vh - 380px);
}
</style>



// WEBPACK FOOTER //
// src/pages/tarefas/CalendarioTarefas.vue